import { SxProps } from "@mui/material";
import { Theme } from "@mui/system";
import { convertToOpacity, getColorFrom } from "../../../utilities/theme/ColorUtils";
import { IChatThreadMessageItemProps } from "./ChatThreadMessageItem.type";

const BORDER_RADIUS_BUBBLE = 10;
const BORDER_WIDTH = 1;
const BACKGROUND_COLOR_ALPHA = 0.05;
const BORDER_COLOR_ALPHA = 0.5;

const styles = ({ isSelf, userRole }: Pick<IChatThreadMessageItemProps, 'isSelf' | 'userRole'>) => {
    const userSpecificStyle = !userRole ? {
        backgroundColor: convertToOpacity('#000000', BACKGROUND_COLOR_ALPHA),
        border: BORDER_WIDTH,
        borderColor: convertToOpacity('#000000', BORDER_COLOR_ALPHA),//borderColor has to be after border
    }
        : Array.isArray(userRole) ?
            {
                background: `linear-gradient(to right bottom, ${convertToOpacity(getColorFrom(userRole[0]), BACKGROUND_COLOR_ALPHA)}, ${convertToOpacity(getColorFrom(userRole[1]), BACKGROUND_COLOR_ALPHA)})`,
                border: BORDER_WIDTH,
                borderColor: 'black',
            }
            : {
                backgroundColor: convertToOpacity(getColorFrom(userRole), BACKGROUND_COLOR_ALPHA),
                border: BORDER_WIDTH,
                borderColor: convertToOpacity(getColorFrom(userRole), BORDER_COLOR_ALPHA),//borderColor has to be after border
            };
    return {
        container: {
            direction: 'row'
        },
        subContainer: {

        },
        bubble: {
            ...userSpecificStyle,
            padding: 1,
            borderTopLeftRadius: isSelf ? BORDER_RADIUS_BUBBLE : 0,
            borderTopRightRadius: isSelf ? 0 : BORDER_RADIUS_BUBBLE,
            borderBottomLeftRadius: BORDER_RADIUS_BUBBLE,
            borderBottomRightRadius: BORDER_RADIUS_BUBBLE,
        } as SxProps<Theme>
    }
};

export default styles;